import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { async } from 'rxjs';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { ApiService } from './../../../../../Services/api.service';
import { CommonServices } from './../../../../../Services/common.service';

@Component({
    selector: 'g10-employee-booking-reports',
    templateUrl: './safe-drop-component.html',
    styleUrls: ['./safe-drop-component.css']
})
export class SafeDropComponent implements OnInit {


    public matFormSize = '12px';
    public filterForm: FormGroup;

    public noDataFoundEnable: boolean = false;
    public excelData = {};
    public currentYear = new Date().getFullYear();
    public minDate = new Date(this.currentYear - 1, 0, 1);
    public maxDate = new Date()
    // public minDate=''
    // public maxDate = new Date();
    public maxEndDate = new Date();
    date = new Date();

    public localStorage;
    public errorObject: any = {
        startDate: '',
        endDate: '',
    }
    public formSubmitted: boolean = false;


    pageNum = 1;
    public routeType = '';
    public routeInfo: any = {};
    public employeeInfo: any = {};
    public safeDropEmpExlData = [];
    public safeDropData = [

    ]

    /* Pagination */
    public showPagination: boolean = true;
    public paginationData = {
        page: 1,
        limit: 10,
        totalPage: 1,
    };

    public showTable: boolean = false;
    public tableData: any = [];
    public cols: any = [
        { key: '#', display: '#' },
        { key: 'empName', display: 'Employee name' ,headerConfig:{ isDefault: true}},
        { key: 'empRefID', display: 'Employee ID', headerConfig:{ isDefault: true}, config: { isUppercase: true, } },
        {
            key: 'vehRegNo', display: 'Reg no',
            config: {
                isVehicle: true,
            },
            headerConfig:{ isDefault: true}
        },
        { key: 'shiftTime', display: 'Shift time',headerConfig:{ isDefault: true} },
        { key: 'routeName', display: 'Route name',headerConfig:{ isDefault: true} },
        { key: 'ppName', display: 'Pickup point name' ,headerConfig:{ isDefault: true}},
        {
            key: 'timeMS', display: 'Date', config: {isDate: true, format: 'dd MMM YYYY'}
        },
        {  key: 'safeDropTime', display: 'Time'},
        { key: 'safeDrop', display: 'Safe drop',headerConfig:{ isDefault: true} },

    ];

    public showDownloadBtn: boolean = false;
    public empDetails: any = {};
    // $scope.date = new Date();

    public isInitial: boolean = true;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private api: ApiService,
        private com: CommonServices,
        private fb: FormBuilder,
        public excel: ExcelExportService,
        private dateAdapter: DateAdapter<Date>
    ) {
        this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy


    }

    getEmployees(ids, resObj, pageObj) {
        this.api.selectedEmployess({
            employeeIDs: ids
        }).then(async (res: any) => {
            if (res && res['status'] == 'success') {
                this.employeeInfo = await this.com.getObjKeyValue(res['data'], 'empRefID', 'name');
                this.processPagination(resObj, pageObj);
            }
        })
    }


    ngOnInit(): void {
        this.filterFormLoad();
        this.getSafeDropEmployeeReports();
    }

    getSafeDropEmployeeReports(page = 1, limit = 10, search?) {
        // console.log("hi", this.safeDropData)
        this.showTable = false;
        let obj={}
        if (this.isInitial) {
             obj = {
                page: page,
                limit: limit,
                startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0,0,0,0)).getTime(),
                endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
            };
        }
        else{
            obj = {
                page: page,
                limit: limit,
                startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
                endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
                empRefID: this.filterForm.value.searchRefId,
                vehRegNo: this.filterForm.value.searchRegNo,
                routeName: this.filterForm.value.searchRouteName
            };
        }
        this.getSafeDropEmployeeExlReports(obj)

        if (search) obj['search'] = search;
        // console.log("table", this.safeDropData)
        this.api.getSafeDropReports(obj).then((res: any) => {
            if (res && res['status'] == 'success') {
                this.safeDropData = res.data;

                this.safeDropData = this.safeDropData.map(x => {
                    let obj = x;
                    x['safeDropTime'] = this.com.convertTime(obj['timeMS']);
                    obj['safeDrop'] = obj['safeDrop'] == true ?
                        '<img src="../../../../../../assets/images/user/tick.png " width="20 ">'
                        : '<img src="../../../../../../assets/images/user/cross.png " width="20 ">';
                    return obj;
                })
                this.showTable = true;
                this.processPagination(res, obj);
            }
        }).catch((err) => {
            console.log(err);
        });



    }

    processPagination(data, req) {
        this.showTable = false;
        this.paginationData = {
            page: req.page,
            limit: req.limit,
            totalPage: this.getTotalCount(data.totCnt, req.limit),
        }
        this.showTable = true;
    }

    getTotalCount(total, limit) {
        let result: any = 1;
        if (total / limit > 0) {
            result = total / limit;
            if (total % limit > 0) result++;
        }
        return Math.floor(result);
    }

    pagination(data) {
        this.getSafeDropEmployeeReports(data.page, data.limit);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
    }

    getSafeDropEmployeeExlReports(obj) {
        this.safeDropEmpExlData = [];
        this.empDetails = {};
        this.api.getSafeDropExlReports(obj).then(async (res: any) => {
            if (res && res.data && res.data.length > 0) {
                this.safeDropEmpExlData = res.data;
                this.safeDropEmpExlData.map((data:any)=>{
                    data['safeDropTime'] = data['timeMS']
                })
                // let empResults = await this.processEmpData(res.data);
                // if (empResults && Array.isArray(empResults) && empResults.length > 0) {
                //     empResults.map((item) => {
                //         if (item.empRefID) {
                //             this.empDetails[item.empRefID] = item;
                //         }
                //     })

                // }
            }
        }).catch((err) => { console.log(err) })
    }

    async processEmpData(data) {

        return new Promise(async (resolve, reject) => {
            try {
                if (data && data.length > 0) {
                    let empsID: any = data.map(itm => itm.empRefID);
                    let employeeIDs = Array.from(new Set(empsID)).join(',');
                    let empData = [];
                    if (empsID.length > 100) {
                        let obj = { employeeIDs };
                        let ping = 1, i = 0;
                        while (ping) {
                            obj['page'] = i + 1;
                            i++;
                            let results = await this.api.selectedEmployess(obj).catch((e) => { console.log('Employee Data retriving issues') });
                            if (results && results['status'] == 'success') {
                                if (results['data'].length <= 0) ping = 0;
                                else empData.push(results['data']);
                            }
                            else ping = 0;

                        }
                    }
                    else {
                        let results = await this.api.selectedEmployess({ employeeIDs }).catch((e) => { console.log('Employee Data retriving issues') });
                        if (results && results['status'] == 'success') {
                            empData = results['data'];
                        }
                    }
                    resolve(empData);
                }
                else resolve([]);
            } catch (error) {
                reject(error);
            }
        });

    }


    filterFormLoad() {
        this.filterForm = this.fb.group({

            searchRegNo: new FormControl(''),
            searchRefId: new FormControl(''),
            searchRouteName: new FormControl(''),
            startDate: new FormControl(new Date(), [Validators.required]),
            endDate: new FormControl(new Date(), [Validators.required]),
        });
    }

    dateFromAction(obj: any = {}, type) {
        obj.selectedDates.map((x: any) => {
            this.filterForm.controls[type].patchValue(x.getTime());
        });
    }

    setMaxDate() {
        let t_maxDate = new Date(this.filterForm.controls.startDate.value);

        //add a day to the date
        t_maxDate.setDate(t_maxDate.getDate() + 30);

        if (new Date() > t_maxDate) {
            this.maxEndDate = t_maxDate;
        }
        else {
            this.maxEndDate = new Date();
        }
        this.checkValidation();

    }

    validation(data) {
        if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
        let objectKeys = Object.keys(this.errorObject);
        let isValid = true;
        for (let i = 0; i < objectKeys.length; i++) {
            let key = objectKeys[i];
            this.errorObject[key] = '';
            if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
                this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
                isValid = false;
            } else if ((key == 'startDate' || key == 'endDate')) {
                if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
                    isValid = false;
                    this.errorObject['invalidDate'] = 'Invalid from date';
                }
                let diff = this.com.timeDiff(data.startDate, data.endDate)

                if(diff.hh > 31*24){
                    isValid = false;
                    this.errorObject['invalidDate'] = 'Maximum 31 days can be select';
                }
            }
        }
        return isValid;
    }

    checkValidation() {
        // console.log('form values', this.filterForm.value);
        let obj = {
            startDate: new Date(this.filterForm.value.startDate).getTime(),
            endDate: new Date(this.filterForm.value.endDate).getTime(),
        }
        if (this.formSubmitted) this.validation(obj);
    }

    onSubmit() {

        // console.log(this.filterForm.value);
        this.formSubmitted = true;
        this.showDownloadBtn = false;
        let checkObj = {
            startDate: new Date(this.filterForm.value.startDate).getTime(),
            endDate: new Date(this.filterForm.value.endDate).getTime(),
            searchRegNo: (this.filterForm.value.searchRegNo),

        }
        let isValid = this.validation(checkObj);
        if (isValid) {
            this.isInitial=false;
            let obj = {
                startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
                endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
            }
            if (this.filterForm.value.searchRegNo != '') obj['searchRegNo'] = this.filterForm.value.searchRegNo;
            if (this.filterForm.value.searchRefId != '') obj['searchRefId'] = this.filterForm.value.searchRefId;
            if (this.filterForm.value.searchRouteName != '') obj['searchRouteName'] = this.filterForm.value.searchRouteName;
            
            this.showDownloadBtn = true;
            // console.log('final obj', obj);

            this.getSafeDropEmployeeReports();
            this.getSafeDropEmployeeExlReports(obj);

        }
    }



    async exportToExcel() {
        let data = [];


        const startDate = new Date(this.filterForm.value.startDate + '');
        const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));
        for (let i = 0; i < this.safeDropEmpExlData.length; i++) {
            let item = this.safeDropEmpExlData[i];
            try {
                let res = {
                    value: [
                        i + 1,
                        item.empRefID ? String(item.empRefID).toUpperCase() : '---',
                        item.empName ? this.com.convertTitleCase(item.empName) : '---',
                        item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
                        item.timeMS ? this.com.timestampToDate(new Date(item.timeMS).getTime(), 'DMY') : '--/--/----',
                        item.safeDropTime ? this.com.convertTime(item.safeDropTime) : '--/--/----',
                        item.shiftTime ? item.shiftTime : '---',
                        item.routeName ? this.com.convertTitleCase(item.routeName) : '---',
                        item.ppName ? this.com.convertTitleCase(item.ppName) : '---',
                        (item.safeDrop || item.safeDrop == 0) ? (item.safeDrop ? 'Yes' : 'No') : '---',
                    ],
                }
                data.push(res);
            } catch (err) {
                console.log(err);
            }
        }


        if (data.length > 0) {

            let rowCount = 2;
            let endCell = 'J';
            let customizedData = [];
            let titleRow = {
                value: ['Safe Drop Report'],
                font: {
                    name: 'Corbel', family: 4, size: 16, bold: true,
                    color: { argb: 'FFFFFFFF' },

                },
                mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
                alignment: {
                    cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
                },
                fill: {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '966462AF' },
                    bgColor: { argb: '966462AF' }
                },
            }

            customizedData.push(titleRow);

            rowCount = rowCount + 2;

            let subtitleRow = {
                value: [
                    "Start Date       : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                    "End Date         : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
                ],
                font: { name: 'Corbel', family: 4, size: 12, },
                mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
            }

            customizedData.push(subtitleRow);

            rowCount = rowCount + 1;
            let headerRow =
            {
                value: ['S No', 'Employee ID', 'Employee name', 'Reg no', 'Date','Time','Shift time' ,'Route name', 'Pickup point name', 'Safe drop'],
                font: { bold: true },
                border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);

            customizedData.push(...data);

            // const excelInfo = {
            //     title: {
            //         title: `Safe Drop Report_`,
            //         subTitleRow: 'Date : ' + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S'),
            //         font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
            //         mergeCells: 'A1:F2',
            //     },
            //     header: {
            //         headers: ['No.', 'Employee Ref Id', 'Employee Name', 'Vehicle Reg No', 'Date', 'Route Name', 'Pick Up point Name', 'Safe Drop',],
            //         fill: {
            //             type: 'pattern',
            //             pattern: 'solid',
            //             fgColor: { argb: 'FFFFFF00' },
            //             bgColor: { argb: 'FF0000FF' }
            //         },
            //         border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            //     },
            //     data: {
            //         data: data,
            //         columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 20 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 25 }]
            //     }
            // };

            if (this.excelData['Safe_Drop_Report'] == undefined) { this.excelData['Safe_Drop_Report'] = {}; }

            this.excelData['Safe_Drop_Report'] = {
                customizedData: customizedData,
                data: {
                    columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 25 }, { colNo: 6, width: 20 }, { colNo: 7, width: 25 }, { colNo: 8, width: 20 },{ colNo: 9, width: 25 },{ colNo: 10, width: 15 }]
                }
            };// excelInfo;

            this.downloadExlReport();

        }

    }

    downloadExlReport() {
        this.excel.generateExcel(this.excelData, 'Safe_Drop_Report_' +" " +this.com.timestampToDate(new Date().getTime(), 'DMY') + '.xlsx');
    }
}
